import { Record as record } from 'immutable';

import { construct, fields } from '../helpers/LinkMapper';

const defaults = {
    numberOfTickets: 0,
    text: ''
};

class FlexiInformation extends record(defaults) {

    static fromJSON (json = {}) {
        return construct(FlexiInformation, json, {
            numberOfTickets: fields.number,
            text: fields.string
        });
    }
}


export default FlexiInformation;
